import { machines } from '../machines/machines-sidecar'
import { scene } from '../main/scene-sidecar'
import { tilesDataShip } from '../tiles/tilesDataShip-sidecar'
import { ITileShip } from '../tiles/tilesShip'
import { cursors } from '../ui/cursors-sidecar'
import { uiStack } from '../ui/uiStack-sidecar'
import { uiOxygen } from '../ui/uiOxygen-sidecar'

export function run(t: ITileShip, isLeft: boolean) {
  let ctx = scene.getContext()
  let std = tilesDataShip.getStandard()

  let mc = machines.findAtSpot(t.i, t.j, (c) => true)
  if (mc) {
    if (mc.data.type === 'pile') {
      cursors.selectMachine(ctx.cursor, mc)
      uiStack.setOpen(true)
    }
    if (mc.data.type === 'o2gen' || mc.data.type === 'o2gen-em') {
      cursors.selectMachine(ctx.cursor, mc)
      uiOxygen.setOpen(true)
    }
  }
}
